import React from 'react';

function SummaryLoading() {
  return (
    <div className="ai-search-summary__loading" data-testid="summary-loading">
      <p className="u-els-margin-bottom">Generating summary. This may take a few seconds.</p>
      <div className="ai-search-summary__loading-heading c-els-loader-shimmer u-els-margin-bottom u-els-margin-left u-els-margin-right" />
      <div className="ai-search-summary__loading-line c-els-loader-shimmer u-els-margin-bottom-1o2 u-els-margin-left u-els-margin-right" />
      <div className="ai-search-summary__loading-line c-els-loader-shimmer u-els-margin-bottom-1x1o2 u-els-margin-left u-els-margin-right" />
      <div className="ai-search-summary__loading-button c-els-loader-shimmer u-els-margin-bottom-1o2" />
    </div>
  );
}

export default SummaryLoading;
